

export const CONFIRM_TYPE_SMS_CODE = 1; // ������������� ����� ��� ���
export const CONFIRM_TYPE_USER_CALL = 2; // ������������� ����� ������ �� ������������
export const CONFIRM_TYPE_BOT_CALL = 3; // ������������� ����� ������ �� ����, ��� � ������ �������� ��������� ������
export const CONFIRM_TYPE_BOT_SPEECH = 4; // ������������� ����� ��������� ���
    export const CONFIRM_TYPE_SIM_PUSH = 5; // ������������� ����� SIM-push

export default {
    CONFIRM_TYPE_SMS_CODE,
    CONFIRM_TYPE_USER_CALL,
    CONFIRM_TYPE_BOT_CALL,
    CONFIRM_TYPE_BOT_SPEECH,
    CONFIRM_TYPE_SIM_PUSH,
}